type Props = <T extends {}, U extends {}>(first: T, second: U) => T & U;

const merge: Props = (first, second) => {
  return { ...first, ...second };
};

export default merge;
